/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonXIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <circle cx="18.5" cy="18.5" r="5" />
      <path d="M16.25,16.25 L20.75,20.75" />
      <path d="M20.75,16.25 L16.25,20.75" />
      <polyline points="12.998 13.441 10 12.367 10 10.322" />
      <path d="M6,10.323 L6,12.367 L2.059,13.779 C1.115,14.117 0.5,15.012 0.5,16.012 L0.5,17.5 L11,17.5" />
      <path d="M11.947,6.236 C11.947,8.854 10.179,10.977 8,10.977 C5.819,10.977 4.053,8.854 4.053,6.236 C4.053,3.621 5.819,1.5 8,1.5 C10.18,1.5 11.947,3.621 11.947,6.236 Z" />
      <path d="M11.916,5.811 C11.784,5.829 11.675,5.817 11.542,5.844 C10.197,6.102 9.334,5.615 8.593,4.319 C8.149,5.17 6.762,5.844 5.621,5.844 C5.059,5.844 4.576,5.729 4.093,5.475" />
      <path d="M14.5,1.5 C16.68,1.5 18.447,3.621 18.447,6.236 C18.447,8.854 16.679,10.977 14.5,10.977" />
      <path d="M18.416,5.811 C18.284,5.829 18.175,5.817 18.042,5.844 C16.697,6.102 15.834,5.615 15.093,4.319" />
      <path d="M16.5,12 L16.5,10.322" />
    </g>
  </svg>
);

export default PersonXIcon;
